import type { FieldListObject } from '@fabric-ui/components';
import type { CalculatedDimension } from '../../CalculateDimensions/types';

export const CALCULATED_PROJECTION_NAME = 'calculated';

export const resolveDimensionProjection = (selectedDim: FieldListObject | undefined, calculatedDimensions: CalculatedDimension[]) => {
  const projection = selectedDim?.mainProjId ?? { name: '', builtIn: true };
  if (projection.name !== CALCULATED_PROJECTION_NAME) {
    return projection;
  }

  return calculatedDimensions.find(({ systemName }) => systemName === selectedDim?.value)?.context?.find(ctx => ctx?.name) ?? projection;
};
